import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Text } from 'components/Typography'
import { BREAKPOINTS, hiddenScrollbarCss, scrollShadowCss } from 'utils/styled'

export const STitleRow = styled.div`
  display: flex;
  align-items: center;
`

export const STitle = styled(Text)`
  font-size: 1.25rem;
  color: var(--c-black);
  font-weight: bold;
  margin-left: 0.75rem;
`

export const SButton = styled(Button)`
  float: right;
  margin-top: 1rem;
  padding: 1rem 3.5rem;

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
  }
`

export const SSongListWrapper = styled.div`
  max-height: min(60vh, 40rem);

  overflow-y: scroll;
  margin: 1rem 0;
  padding: 0 1rem;

  ${hiddenScrollbarCss}

  ${scrollShadowCss}

  @media ${BREAKPOINTS.MD.max} {
    margin: 2rem 0;
  }
`

export const modalCss = css`
  @media ${BREAKPOINTS.MD.min} {
    max-width: 30rem;
  }
`

export const modalContentCss = css`
  padding-left: 2rem;
  padding-right: 2rem;
  @media ${BREAKPOINTS.MD.max} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`
